// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"CreateError_actionButton__2SJEi","title":"CreateError_title__dHW92","text":"CreateError_text__b4nuT"};